import AirPorts from "../data/airports.json";

const getAirPortName = (code: string): string => {
  const airPort = AirPorts.find((airPort) => airPort.code === code);
  if (airPort !== null && airPort !== undefined) {
    return airPort.name;
  }
  return "N/A";
};

export { getAirPortName };